import { BaseHydratedCustomer } from './types/types';

export const generateCustomerLabel = (customer: BaseHydratedCustomer) => {
	const first_name = customer.first_name || 'N/A';
	const last_name = customer.last_name || 'N/A';
	const full_name = first_name.concat(' ', last_name);

	if (customer.entity === 'non_clinic') {
		return full_name.concat(' - ', customer.organization?.name || 'N/A');
	} else if (customer.entity === 'clinic') {
		if (customer.national_provider_identifier)
			return full_name
				.concat(' - ', customer.national_provider_identifier)
				.concat(', ', customer.organization?.name || 'N/A');

		return full_name.concat(' - ', customer.organization?.name || 'N/A');
	}

	return full_name;
};
